import React from 'react'
import { Donut } from './Donut'
import { Progress, Spinner } from 'reactstrap';
import './donutChart.css';
import { defaultColors } from '../helpersCharts';

export const DonutChart = ({ idChart, widthChart, heightChart, dataChart, typesChart, withLegendProgressBar = false, loadding, redirect }) => {

    const clickRedirectRef = (value) => document.getElementById(`${idChart}${value.identifier}`).click();

    const getPercent = (value) => {
        let totalData = 0;
        dataChart.forEach((op) => totalData = op.value + totalData);
        const percent = Math.ceil((value * 100) / totalData)
        return percent > 0 ? percent : 0;
    }

    return (
        <>
            {
                loadding ?

                    <div className="d-flex justify-content-center align-items-center w-100" style={{ minHeight: '260px' }}>
                        <Spinner />
                    </div>

                    :
                    <div className='box-chart-legend'>

                        <Donut data={dataChart} widthChart={widthChart} heightChart={heightChart} redirectToClicked={clickRedirectRef} />

                        {withLegendProgressBar ?

                            <div className='box-progress'>
                                {dataChart.map((op, i) => {
                                    return (
                                        <div /* id={`legendPlace${op.identifier}`} */ key={i} className='p-1' /* ref={redirectRef} */ onClick={() => redirect(op)}>
                                            <p className='m-0 title-progress-donut'>{op.type}</p>
                                            <p className='m-0 value-progress-donut'>{op.value}</p>
                                            <Progress multi className=''>
                                                <Progress bar type={'button'} value={getPercent(op.value)} style={{ backgroundColor: defaultColors[i] }} />
                                            </Progress>
                                        </div>
                                    )
                                })}
                            </div>

                            :
                            null
                        }

                        {/* I put this map to execute the function because it doesn't work from the graph, it remains with the static data and they don't change */}
                        {dataChart.map((op, i) => <div id={`${idChart}${op.identifier}`} key={i} className='d-none' onClick={() => redirect(op)} />)}
                    </div>
            }
        </>
    )
}
